/**
 * Debounce hook - viivästää arvon päivitystä
 * Hyödyllinen hakukentille, joissa ei haluta tehdä API-kutsua
 * jokaisella näppäinpainalluksella.
 */

import { useState, useEffect } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
